import { DesktopTimePicker, DesktopTimePickerProps } from "@mui/x-date-pickers";
import { useState } from "react";

const defaultTextField = {
  fullWidth: true,
  variant: "outlined" as const,
  InputLabelProps: { shrink: true as const },
  sx: {
    "& .MuiInputBase-input": {
      fontSize: "14px",
    },
    "& input::placeholder": {
      fontSize: "13px",
      opacity: 1,
    },
  },
};

export function CustomTimePicker<TDate extends Date>(
  props: DesktopTimePickerProps<TDate, false>,
) {
  const [openTime, setOpenTime] = useState<boolean>(false);

  const handleOpenTimePicker = () => {
    setOpenTime(true);
  };

  const handleCloseTimePicker = () => {
    setOpenTime(false);
  };

  const mergedSlotProps = {
    ...(props.slotProps ?? {}),
    textField: {
      ...(defaultTextField as Record<string, unknown>),
      ...(props.slotProps?.textField ?? {}),
      sx: {
        ...(defaultTextField.sx ?? {}),
        ...((props.slotProps?.textField as any)?.sx ?? {}),
      },
      onClick: handleOpenTimePicker,
    },
  };

  return (
    <DesktopTimePicker
      {...props}
      slotProps={
        mergedSlotProps as unknown as DesktopTimePickerProps<
          TDate,
          false
        >["slotProps"]
      }
      open={openTime}
      onOpen={handleOpenTimePicker}
      onClose={handleCloseTimePicker}
    />
  );
}

export default CustomTimePicker;
